import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Space, Input, Row, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./location.filter.css";
import axios from "axios";
import {
  fetchKeySearchLocation,
  searchLocation,
  fetchRegionSuggestionsInit,
  fetchKeySearchDynamicLocation,
} from "../../../../redux/actions";
import { debounce } from "../../../../shared/helpers";
import { useParams } from "react-router-dom";

const FilterRegion = (props) => {
  const dispatch = useDispatch();
  const { id, name } = useParams();
  const [regionValue, setRegionValue] = useState([]);
  const [defaultValue, setDefaultValue] = useState();

  const [searchtext, setSearch] = useState();
  const filters = useSelector(
    (state) => state.searchSkillListingReducer.filters
  );
  const locations = useSelector(
    (state) => state.searchSkillListingReducer.locations
  );
  const regionSuggestions = useSelector(
    (state) => state.searchSkillListingReducer.regionSuggestions
  );
  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    if (props.regionObj) {
      setDefaultValue(props.regionObj);
    }
  }, [props]);


  useEffect(() => {
    var options = [];
    if (regionSuggestions && regionSuggestions.location) {
      for (var i = 0; i < regionSuggestions?.location?.length; i++) {
        options = [
          ...options,
          {
            value: regionSuggestions.location[i].RegionName,
            value2: regionSuggestions[i].RegionId,
            count:0,
          },
        ];
      }

      //append selected cities in suggestions array
      if (props.check && props.check.length > 0) {
        for (var j = 0; j < props.check.length; j++) {
          options = [
            {
              value: props.check[j].name,
              value2: props.check[j].id,
              count: 0,
            },
            ...options,
          ];
        }
      }
      //creating unique array
      var uniqueArr = [];
      options.forEach((option) => {
        if (!uniqueArr.some((item) => item.value === option.value)) {
          uniqueArr.push(option);
        }
      });

      setRegionValue(uniqueArr.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value?.toLowerCase())));
      // setRegionValue(options);
    } else {
      setRegionValue([]);
    }
  }, [regionSuggestions]);

  useEffect(() => {
    var options = [];
    if (regionSuggestions?.length > 0) {
      for (var i = 0; i < regionSuggestions?.length; i++) {
        options = [
          ...options,
          {
            value: regionSuggestions[i].RegionName,
            value2: regionSuggestions[i].RegionId,
            count:0
          },
        ];
      }
      //append selected cities in suggestions array
      if (props.check && props.check.length > 0) {
         for (var j = 0; j < props.check.length; j++) {
            options = [
            {
              value: props.check[j].name,
              value2: props.check[j].id,
              count: 0,
            },
             ...options,
         ];
         }
      }
   //creating unique array
     var uniqueArr = [];
   options.forEach(option => {
      if (!uniqueArr.some(item => item.value === option.value)) {
         uniqueArr.push(option);
      }
   });

      setRegionValue(uniqueArr.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value?.toLowerCase())));
    }
  }, [regionSuggestions]);

  const onChange = (e) => {
    // let value = JSON.parse(e.target.value)
    const { value, value2, value3, count, checked } = e.target;

    if (e.target.checked) {
      props.setCheckRegionId((prev) => [...prev, parseInt(e.target.value2)]); // Add the value to the array
      props.setcheck((prev) => [
        ...prev,
        {
          name: e.target.value,
          id: parseInt(e.target.value2),
          count:0,
        },
      ]);
    } else {
      props.setCheckRegionId(
        props?.checkRegionId.filter((item) => item !== value2)
      ); // Remove the value from the array
      props.setcheck(
        props?.check.filter((item) => {
          return item.id !== value2 && item.ids !== value;
        })
      );
    }
    // props.setcheck(value.value);
    // props.setregionObj(value)
    // props.setCheckRegionId(parseInt(value.value2));

    // if (props.addQuery) {
    //    props.addQuery('City', e.target.value)
    // }
  };

  const onLocationSearch = (value) => {
    if (Object.keys(props.searchLocationFilter).length) {
      const query = `region=${value}`;
      const params = {
        value: query,
        body: props.searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    } else {
      const obj = {
        value: value,
        type: "region",
      };
      const params = { obj };
      dispatch(fetchRegionSuggestionsInit(params));
    }
  };

  useEffect(() => {
    if (props.emptyRegionInput == "" && !props.searchLocationFilter) {
      dispatch(fetchRegionSuggestionsInit());
    }
  }, [props.emptyRegionInput]);

  const getCheckedValues = (value2) => {
    if (props.checkRegionId?.includes(value2)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="location-suggestion-view">
      <Input
        onChange={debounce((e) => onLocationSearch(e.target.value))}
        className="filter-search-input"
        placeholder="Search"
        value={props.emptyRegionInput}
        prefix={<SearchOutlined />}
      />
      {/* <Radio.Group onChange={onChange} className='location-radios-grp' value={props.locObj}> */}
      <Space direction="vertical" className={"infinite-scroller mobile-no-scroller"} style={{ overflow:'auto',width: "98%" }}>
        {!searchtext ? (
          <div
            className={`location-lists-container ${
              regionValue?.length > 5 ? "show-scrollbar" : ""
            }`}
          >
            {regionValue?.length ? regionValue.map((items, index) => {
              return items?.value ? (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: index == 0 ? "0px" : "10px",
                  }}
                  key={index}
                >
                  {/* <Radio 
                           type={'radio'} 
                           key={index} 
                           value={JSON.stringify(items)} 
                           className="location-radio" 
                           onChange={onChange} 
                           // checked={items?.value == props?.regionObj?.value}
                           checked={props?.regionObj?.value?
                                       items?.value == props?.regionObj?.value
                                       :
                                       items?.value == props?.regionObj
                              }
                           
                           >

                                 {items.value}
                              </Radio> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "inherit",
                    }}
                  >
                    <Checkbox
                      checked={getCheckedValues(items.value2)}
                      onChange={onChange}
                      value={items.value}
                      value2={items.value2}
                      value3={items.value3}
                      count = {items.count}
                      key={index}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {" "}
                        <div>{items?.value}</div>
                      </div>
                    </Checkbox>
                    {/* {id || props?.fromCandMkt ? null : <> <div className="countDiv">({items?.count})</div> </>} */}
                  </div>
                </div>
              ) : null;
            }) : <div style={{display: 'flex', justifyContent: 'center', color: '#7e7e7e'}}> No results found </div> }
          </div>
        ) : (
          searchtext.map((items, index) => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "inherit",
                }}
                key={index}
              >
                <Radio
                  key={index}
                  value={defaultValue ? defaultValue : JSON.stringify(items)}
                  className="location-radio"
                  onChange={onChange}
                  // checked={items?.value == props?.regionObj}
                  checked={
                    props?.regionObj?.value
                      ? items?.value == props?.regionObj?.value
                      : items?.value == props?.regionObj
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {" "}
                    <div>{items.value}</div>
                  </div>
                </Radio>
                {/* {!id ? <> <div className="countDiv">({items?.count})</div> </> : null} */}
              </div>
            );
          })
        )}
      </Space>
      {/* </Radio.Group> */}
    </div>
  );
};
export default FilterRegion;
